import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  constructor(private httpClient: HttpClient) {}

  /**
   * Generate a url using the environments
   * @param {any} url
   * @returns string
   */

  /**
   * Sends a request on server side. Default switch case will be used for GET requests.
   * @param {any} url
   * @param {string} type
   * @param {any} formData
   * @returns Promise
   */
  sendRequest<T = any>(
    url: any,
    type: string,
    formData: any = {},
    options: {
      headers?: HttpHeaders
      observeEvents?: boolean
      responseType?: 'blob' | 'text'
    } = {}
  ): Observable<T> {
    const params = this.transformFormDataToParams(formData || {})

    switch (type.toLowerCase()) {
      case 'post':
        return this.httpClient.post<T>(url, formData)
      case 'put':
        return this.httpClient.put<T>(url, formData)
      case 'patch':
        return this.httpClient.patch<T>(url, formData)
      case 'delete':
        return this.httpClient.delete<T>(url, { params: params })
      case 'upload_file':
        return this.httpClient.post<T>(url, formData)
      case 'get':
        return this.httpClient.get<T>(url, { params, responseType: options.responseType as any });
      default:
        return this.httpClient.get<T>(url, { params: params })
    }
  }

  /**
   * Makes params from form data
   * @param any
   * @returns HttpParams
   */
  private transformFormDataToParams(formData: any) {
    let params = new HttpParams()
    if (Object.keys(formData).length) {
      Object.keys(formData).forEach(key => {
        if (Array.isArray(formData[key])) {
          formData[key].forEach((k: any) => {
            params = params.append(key + '[]', k)
          })
        } else {
          params = params.append(key, formData[key])
        }
      })
    }
    return params
  }
}
